import{makeStyles as i}from"@material-ui/core";var e=i((function(i){return{root:{display:"flex",flexDirection:"column",gap:i.spacing(3)},files:{display:"flex",flexDirection:"column",gap:i.spacing(2)}}}));export{e as useStyles};
